module.exports = __webpack_public_path__ + "49eb66a1173faa5742ca0ec3c45e0ca3.svg";